import { render, staticRenderFns } from "./BookingInfo.vue?vue&type=template&id=467a00f2&scoped=true&"
import script from "./BookingInfo.vue?vue&type=script&lang=js&"
export * from "./BookingInfo.vue?vue&type=script&lang=js&"
import style0 from "./BookingInfo.vue?vue&type=style&index=0&id=467a00f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467a00f2",
  null
  
)

export default component.exports